import { I18nOptions, createI18n } from 'vue-i18n';
import en from './locales/en'
import fr from './locales/fr'

const instance = createI18n({
  locale: navigator.language.includes('-') ? navigator.language.split('-')[0] : navigator.language,
	legacy: false,
  fallbackLocale: 'en',
  globalInjection: true,
  messages: {
		en,
		fr,
	},
} as I18nOptions);

export default instance;

export const i18n = instance.global;
